import React from "react"
import { Row, Col } from "reactstrap"
import ContainerMax from "components/shared/ContainerMax"
import styled from "styled-components"
import Social from "components/shared/Social"

const NavFullFooterWrap = styled.div`
  width: 100%;
  padding: 1.25rem 0;
  background-color: ${props => props.theme.colors.primary};
`

const ContainerMaxStyled = styled(ContainerMax)`
  padding-left: 2rem;
  padding-right: 2rem;
`

const SocialStyles = styled.div`
  list-style: none;
  text-align: center;
  padding: 0;
  margin: 0;
  li {
    display: inline-block;
    a {
      color: ${props => props.theme.colors.white} !important;
      font-size: 1.5rem;
      padding: 0 1rem;
    }
  }
`

const NavFullFooter = (props) => {
  return(
    <NavFullFooterWrap>
      <ContainerMaxStyled>
        <Row className="text-center">
          <Col xs={12}>
            <Row className="justify-content-center">
              <Col xs={12} md="auto" className="pt-2 pt-md-0">
                <SocialStyles>
                  <Social />
                </SocialStyles>
              </Col>
            </Row>
          </Col>
        </Row>
      </ContainerMaxStyled>
    </NavFullFooterWrap>
  )
}

export default NavFullFooter